import { render, staticRenderFns } from "./MaterialEdit.vue?vue&type=template&id=72004e2c&scoped=true&"
import script from "./MaterialEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialEdit.vue?vue&type=script&lang=js&"
import style0 from "./MaterialEdit.vue?vue&type=style&index=0&id=72004e2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72004e2c",
  null
  
)

export default component.exports